import {NgModule} from '@angular/core';
import {CommunicationContentModelConverter} from './api/entity/converter/communicationContentModel.converter';
import {
    CommunicationContentModelDataServiceAdapter
} from './impl/service/ngrx/communicationContentModelDataService.adapter';
import {CommunicationContentModelDataService} from './impl/service/ngrx/communicationContentModelData.service';
import {CommunicationContentModelRepository} from './impl/service/ngrx/communicationContentModel.repository';
import {
    CommunicationContentModelSummaryDataServiceAdapter
} from './impl/service/ngrx/communicationContentModelSummaryDataService.adapter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {
    CommunicationContentModelSummaryConverter
} from './api/entity/converter/communicationContentModelSummary.converter';

@NgModule({
    providers: [
        CommunicationContentModelConverter,
        CommunicationContentModelSummaryConverter,
        CommunicationContentModelDataService,
        CommunicationContentModelRepository,
        CommunicationContentModelDataServiceAdapter,
        CommunicationContentModelSummaryDataServiceAdapter
    ]
})
export class CommunicationContentModelModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: CommunicationContentModelRepository,
                dataService: CommunicationContentModelDataService,
    ) {

        entityDataService.registerServices({
            CommunicationContentModel: dataService,
        });

        entityServices.registerEntityCollectionServices({
            CommunicationContentModel: repository,
        });

        // errorMessages.set('REPORT_COMPONENT_SAVE_MAXIMUM_COMPONENT_COUNT_REACHED', 'Vous avez atteint votre quota pour ce type de composant');
    }
}
